<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal
    full-width
    :show.sync="show"
    :show-close-button="false"
    :on-close="onClose"
  >
    <div
      v-on-clickaway="onClose"
      class="bg-white dark:bg-slate-900 flex flex-col h-[inherit] w-[inherit]"
    >
      <div class="items-center flex h-16 justify-between py-2 px-6 w-full">
        <div class="items-center flex justify-start min-w-[15rem]" @click.stop>
          <thumbnail
            :username="senderDetails.name"
            :src="senderDetails.avatar"
          />
          <div
            class="flex items-start flex-col justify-center ml-2 rtl:ml-0 rtl:mr-2"
          >
            <h3
              class="sub-block-title inline-block leading-[1.4] m-0 p-0 capitalize"
            >
              <span
                class="text-slate-800 dark:text-slate-100 overflow-hidden whitespace-nowrap text-ellipsis"
              >
                {{ senderDetails.name }}
              </span>
            </h3>
            <span
              class="text-xs m-0 p-0 text-slate-400 dark:text-slate-200 overflow-hidden whitespace-nowrap text-ellipsis"
            >
              {{ readableTime }}
            </span>
          </div>
        </div>
        <div
          class="items-center text-slate-700 dark:text-slate-100 flex font-semibold justify-start min-w-0 p-1 w-auto text-block-title"
        >
          <span
            class="text-slate-700 dark:text-slate-100 overflow-hidden whitespace-nowrap text-ellipsis"
          >
            {{ fileNameFromDataUrl }}
          </span>
        </div>
        <div
          class="items-center flex gap-2 justify-end min-w-[15rem]"
          @click.stop
        >
          <woot-button
            v-if="isDownloadAllowed /* d99d */"
            size="large"
            color-scheme="secondary"
            variant="clear"
            icon="arrow-download"
            @click="onClickDownload"
          />
          <woot-button
            size="large"
            color-scheme="secondary"
            variant="clear"
            icon="dismiss"
            @click="onClose"
          />
        </div>
      </div>
      <div class="items-center flex h-full justify-center w-full">
        <div class="flex justify-center min-w-[6.25rem] w-[6.25rem]">
          <woot-button
            v-if="hasMoreThanOneAttachment"
            size="large"
            variant="smooth"
            color-scheme="primary"
            icon="chevron-left"
            class="rtl:rotate-180"
            :disabled="activeImageIndex === 0"
            @click.stop="showPrevious"
          />
        </div>
        <div class="flex items-center flex-col justify-center w-full h-full">
          <div>
            <img
              v-if="isImage"
              :key="activeAttachment.message_id"
              :src="activeAttachment.data_url"
              class="modal-image skip-context-menu my-0 mx-auto"
              @click="onClick"
            />
            <video
              v-if="isVideo"
              :key="activeAttachment.message_id"
              :src="activeAttachment.data_url"
              controls
              playsInline
              class="modal-video skip-context-menu my-0 mx-auto"
              @click.stop
            />
            <audio
              v-if="isAudio"
              :key="activeAttachment.message_id"
              controls
              class="skip-context-menu"
              @click.stop
            >
              <source :src="`${activeAttachment.data_url}?t=${Date.now()}`" />
            </audio>
          </div>
          <iframe
            v-if="isPdf"
            :key="activeAttachment.data_url"
            :src="activeAttachment.data_url"
            :title="fileNameFromDataUrl"
            class="skip-context-menu w-full h-full border-0"
            @click.stop
          />
          <div
            v-if="isOtherFile"
            class="flex flex-col items-center gap-4 text-slate-600 dark:text-slate-200"
            @click.stop
          >
            <span class="material-symbols-outlined text-[64px] text-slate-400">
              description
            </span>
            <woot-button
              v-if="isDownloadAllowed /* d99d */"
              color-scheme="primary"
              icon="arrow-download"
              @click="onClickDownload"
            >
              {{ $t('CONVERSATION.DOWNLOAD') }}
            </woot-button>
          </div>
        </div>
        <div class="flex justify-center min-w-[6.25rem] w-[6.25rem]">
          <woot-button
            v-if="hasMoreThanOneAttachment"
            size="large"
            variant="smooth"
            color-scheme="primary"
            :disabled="activeImageIndex === attachments.length - 1"
            icon="chevron-right"
            class="rtl:rotate-180"
            @click.stop="showNext"
          />
        </div>
      </div>
      <div class="items-center flex h-16 justify-center w-full py-2 px-6">
        <div
          class="items-center rounded-sm flex font-semibold justify-center min-w-[5rem] p-1 bg-slate-25 dark:bg-slate-800 text-slate-600 dark:text-slate-200 text-block-title"
        >
          <span class="count" dir="ltr">
            {{ `${activeImageIndex + 1} / ${attachments.length}` }}
          </span>
        </div>
      </div>
    </div>
  </woot-modal>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import {
  isEscape,
  hasPressedArrowLeftKey,
  hasPressedArrowRightKey,
} from 'shared/helpers/KeyboardHelpers';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import timeMixin from 'dashboard/mixins/time';
import rtlMixin from 'shared/mixins/rtlMixin';

import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

const ALLOWED_FILE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
};

export default {
  components: {
    Thumbnail,
  },
  mixins: [eventListenerMixins, clickaway, timeMixin, rtlMixin],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    attachment: {
      type: Object,
      required: true,
    },
    allAttachments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeAttachment: {},
      activeFileType: '',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentChatAttachments: 'getSelectedChatAttachments',
    }),
    // d99d
    isDownloadAllowed() { // for bafi in iframe it doesn't work
      return window.location === window.parent.location //check that we are in not iframe
    },
    // .
    attachments() {
      const attachments = this.allAttachments.length
        ? this.allAttachments
        : this.currentChatAttachments.filter(item => item.data_url);
      return attachments.some(
        item => item.data_url === this.attachment.data_url
      )
        ? attachments
        : [this.attachment];
    },
    activeImageIndex() {
      return Math.max(
        this.attachments.findIndex(
          attachment => attachment.data_url === this.activeAttachment.data_url
        ),
        0
      );
    },
    hasMoreThanOneAttachment() {
      return this.attachments.length > 1;
    },
    readableTime() {
      if (!this.activeAttachment.created_at) return '';
      const time = this.messageTimestamp(
        this.activeAttachment.created_at,
        'LLL d yyyy, h:mm a'
      );
      return time || '';
    },
    isImage() {
      return this.activeFileType === ALLOWED_FILE_TYPES.IMAGE;
    },
    isVideo() {
      return this.activeFileType === ALLOWED_FILE_TYPES.VIDEO;
    },
    isAudio() {
      return this.activeFileType === ALLOWED_FILE_TYPES.AUDIO;
    },
    isMedia() {
      return this.isImage || this.isVideo || this.isAudio;
    },
    isPdf() {
      return (
        !this.isMedia &&
        this.fileNameFromDataUrl.split('.').pop().toLowerCase() === 'pdf'
      );
    },
    isOtherFile() {
      return !this.isMedia && !this.isPdf;
    },
    senderDetails() {
      const {
        name,
        available_name: availableName,
        avatar_url,
        thumbnail,
        id,
      } = this.activeAttachment?.sender || this.attachment?.sender || {};
      const currentUserID = this.currentUser?.id;
      if (currentUserID === id) {
        return { name: 'You', avatar: thumbnail || avatar_url || '' };
      }
      return {
        name: name || availableName || this.$t('CONVERSATION.BOT'),
        avatar: thumbnail || avatar_url || '',
      };
    },
    fileNameFromDataUrl() {
      const { data_url: dataUrl } = this.activeAttachment;
      if (!dataUrl) return '';
      const fileName = dataUrl.split('?')[0].split('/').pop();
      try {
        return decodeURIComponent(fileName);
      } catch (e) {
        return fileName;
      }
    },
  },
  mounted() {
    this.setImageAndVideoSrc(
      this.attachments.find(
        item => item.data_url === this.attachment.data_url
      ) || this.attachment
    );
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    showPrevious() {
      const attachment = this.attachments[this.activeImageIndex - 1];
      if (attachment) this.setImageAndVideoSrc(attachment);
    },
    showNext() {
      const attachment = this.attachments[this.activeImageIndex + 1];
      if (attachment) this.setImageAndVideoSrc(attachment);
    },
    setImageAndVideoSrc(attachment) {
      this.activeAttachment = attachment;
      this.activeFileType = attachment.file_type;
    },
    onKeyDownHandler(e) {
      if (isEscape(e)) {
        this.onClose();
      } else if (hasPressedArrowLeftKey(e)) {
        if (this.isRTLView) this.showNext();
        else this.showPrevious();
      } else if (hasPressedArrowRightKey(e)) {
        if (this.isRTLView) this.showPrevious();
        else this.showNext();
      }
    },
    onClickDownload() {
      const link = document.createElement('a');
      link.href = this.activeAttachment.data_url;
      link.download = this.fileNameFromDataUrl;
      link.click();
    },
    // d99d
    onClick() {
      const imageElement = document.querySelector('.modal-image');
      if (imageElement) {
        imageElement.classList.toggle('zoomed');
      }
    },
  },
};
</script>
<!--d99d-->
<style scoped>
.modal-image.zoomed {
  cursor: zoom-out;
  transform: scale(1.8);
  transition: transform 0.3s ease;
}
</style>
